import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import styles from './ListRow.module.scss';

export interface ListRowProps {
  /** Leading rank/number column. */
  rank?: React.ReactNode;
  /** Leading media (cover art / avatar). */
  media?: React.ReactNode;
  title: React.ReactNode;
  sub?: React.ReactNode;
  /** Trailing content (stats, delta, actions). */
  trailing?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const ListRowComponent: React.FC<ListRowProps> = ({ rank, media, title, sub, trailing, onClick, className }) => {
  const interactive = onClick !== undefined;
  return (
    <div
      className={clsx(styles.row, interactive && styles.interactive, className)}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={
        interactive
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
    >
      {rank !== undefined && rank !== null && <span className={clsx(styles.rank, 'fig')}>{rank}</span>}
      {media}
      <div className={styles.info}>
        <div className={styles.name}>{title}</div>
        {sub !== undefined && sub !== null && <div className={styles.sub}>{sub}</div>}
      </div>
      {trailing !== undefined && trailing !== null && <div className={styles.trailing}>{trailing}</div>}
    </div>
  );
};

export const ListRow = TypedMemo(ListRowComponent);
